import { __spreadArrays } from "tslib";
import { ReportColumnType } from 'peekdata-datagateway-api-sdk';
import { arrayMove } from 'react-sortable-hoc';
import { ISelectedNode } from "../../models/node";
import { IAction } from "../action";
import { actionTypes, ISelectNodePayload, ISortNodePayload, ISortOrderNodePayload } from "../actions";
import { getSortedItems } from "../../utils/SortingUtils";
var initialState = [];
export function selectedMetrics(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.loadScopeNames:
            if (action.payload) {
                return state;
            }
            return initialState;
        case actionTypes.metricsLoaded:
        case actionTypes.dataModelNamesLoaded:
            return initialState;
        case actionTypes.addOption:
            if (action.payload !== ReportColumnType.metric) {
                return state;
            }
            return __spreadArrays(state, [
                {},
            ]);
        case actionTypes.sortOrder:
            return getSortedItems(state, action.payload, ReportColumnType.metric);
        case actionTypes.sortEnd:
            var _a = action.payload, oldIndex = _a.oldIndex, newIndex = _a.newIndex, optionType = _a.optionType;
            if (optionType !== ReportColumnType.metric) {
                return state;
            }
            return arrayMove(state, oldIndex, newIndex);
        case actionTypes.setSelectedMetrics:
            return action.payload;
        case actionTypes.selectOption:
            var payload_1 = action.payload;
            if (!payload_1 || payload_1.optionType !== ReportColumnType.metric) {
                return state;
            }
            return state.map(function (item) {
                if (item.value) {
                    return item;
                }
                return {
                    value: payload_1.value,
                    sorting: null,
                };
            });
        case actionTypes.unselectOption:
            var _b = action.payload, unselectedOptionValue_1 = _b.value, unselectOptionType = _b.optionType;
            if (unselectOptionType !== ReportColumnType.metric) {
                return state;
            }
            return state.filter(function (item) { return item.value !== unselectedOptionValue_1; });
        default:
            return state;
    }
}
